import { type FC, useState } from 'react';
import { Text, Box, FormControl } from '../../../base-components';
import type { CollapseFormInputProps } from './types';
import { useCollapseFormContext } from '../CollapseFormContext';

export interface DateSelectProps extends CollapseFormInputProps {
  selectedDate?: string;
  onChange?: (arg: string) => void;
}

const DateSelect: FC<DateSelectProps> = ({
  isRequired,
  label,
  selectedDate = '',
  onChange = () => {},
}) => {
  const { view } = useCollapseFormContext();
  const [currentSelection, setCurrentSelection] = useState(selectedDate);

  const handleSelectDate = (newVal: string) => {
    setCurrentSelection(newVal);
    onChange(newVal);
  };

  const formattedDate = new Date(currentSelection).toLocaleDateString('en-US', {
    month: 'numeric',
    day: 'numeric',
    year: '2-digit',
  });

  switch (view) {
    case 'write':
      return (
        <FormControl isRequired={isRequired}>
          <FormControl.Label>{label}</FormControl.Label>
          {/* V2 */}
        </FormControl>
      );
    case 'read':
      return (
        <Box display="flex" flexDirection="row" flexWrap="wrap">
          <Text fontWeight="bold">{label} </Text>
          <Text>{formattedDate}</Text>
        </Box>
      );
      return null;
    default:
      return null;
  }
};

export default DateSelect;
